const EVENTS_API = '/api/events';

const ALLOWED_EVENTS = new Set([
  'tool_opened', 'pdf_exported', 'backup_created', 'backup_restored',
  'license_validated', 'upgrade_clicked', 'backup_deleted',
]);

function isLocalDevelopment(): boolean {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
}

export function track(
  eventName: string,
  payload?: {
    featureKey?: string;
    anonymousSessionId?: string;
    metadata?: Record<string, unknown>;
  },
): void {
  // Le serveur Vite ne fournit pas les fonctions Netlify : ne pas générer
  // d'erreur réseau en développement local. Le tracking reste actif en prod.
  if (isLocalDevelopment()) return;

  if (!ALLOWED_EVENTS.has(eventName)) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`[track] Événement "${eventName}" non autorisé.`);
    }
    return;
  }

  const body: Record<string, unknown> = { event_name: eventName };
  if (payload?.featureKey) body.feature_key = payload.featureKey;
  if (payload?.anonymousSessionId) body.anonymous_session_id = payload.anonymousSessionId;
  if (payload?.metadata) body.metadata = payload.metadata;

  fetch(EVENTS_API, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }).catch(() => {});
}
